import React from 'react';
import { skills } from '../data/mock';
import { Badge } from './ui/badge';
import { Code, Database, Shield, Cpu, Server, Lock } from 'lucide-react';

const Skills = () => {
  const skillCategories = [
    {
      title: "Languages",
      icon: <Code size={24} />,
      items: skills.languages,
      color: "skill-category-1"
    },
    {
      title: "Frameworks",
      icon: <Server size={24} />,
      items: skills.frameworks,
      color: "skill-category-2"
    },
    {
      title: "ML & AI",
      icon: <Cpu size={24} />,
      items: skills.mlAi,
      color: "skill-category-3"
    },
    {
      title: "Databases",
      icon: <Database size={24} />,
      items: skills.databases,
      color: "skill-category-4"
    },
    {
      title: "DevOps & Tools",
      icon: <Server size={24} />,
      items: skills.devOps,
      color: "skill-category-5"
    },
    {
      title: "Protocols",
      icon: <Code size={24} />,
      items: skills.protocols,
      color: "skill-category-6"
    },
    {
      title: "Security",
      icon: <Shield size={24} />,
      items: skills.security,
      color: "skill-category-7"
    }
  ];

  return (
    <section id="skills" className="section-padding section-dark">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Technical Skills</h2>
          <div className="section-underline"></div>
        </div>
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className={`skill-category ${category.color}`}>
              <div className="skill-category-header">
                <div className="skill-category-icon">{category.icon}</div>
                <h3 className="skill-category-title">{category.title}</h3>
              </div>
              <div className="skill-items">
                {category.items.map((skill, idx) => (
                  <Badge key={idx} className="skill-badge">
                    {skill}
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;